<mat-toolbar>
  <img class="h-11" src="godigitaltc_logo.png" alt="GDTC" />
  <mat-divider class="h-7 pl-4" vertical></mat-divider>
  <p class="headline-small mb-0! pl-4">Timesheet Validation Application</p>
  <span class="flex-auto"></span>
  @if (showHelpButton()) {
    <button
      class="mr-4"
      matButton="elevated"
      routerLink="/guides"
      matTooltip="TVA Guides"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      [class.overlay-active]="isOpen"
      (click)="isOpen = !isOpen"
    >
      Guides
    </button>
    <ng-template
      cdkConnectedOverlay
      cdkConnectedOverlayHasBackdrop
      cdkConnectedOverlayBackdropClass=""
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen"
      [cdkConnectedOverlayOffsetY]="12"
      (detach)="isOpen = false"
    >
      <mat-card appearance="outlined">
        <mat-card-content> Got questions? This might help. </mat-card-content>
      </mat-card>
    </ng-template>
  }
  <app-user-profile></app-user-profile>
</mat-toolbar>
